// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WithScrollToTop-module__wrapper","show":"WithScrollToTop-module__show"};